import { JobBillingDashboard } from '@/components/Domains/Jobs'
import { withRequiredPermissions } from '@/lib/permissions'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/jobs/$jobId/_layout/billing')({
  component: () => <Page />,
})

const Page = withRequiredPermissions(JobBillingDashboard, {
  requiredPermissions: [{ action: 'read', subject: 'bill' }],
})
